import {
  ITranslateViewModel,
  TLocalTranslateObject,
} from "./__types__/ITranslateViewModel";
import { Statuses } from "../statuses";
import {
  ITranslatesRepository,
  TTechnicalTranslateResponse,
} from "@repositories/translates/types";
import { TranslatesRepository } from "@repositories/translates";
import { AxiosRequestClient } from "@modules/request";
import { ITranslateEntity, TranslateEntity } from "@entities/TranslateEntity";
import { IRootTreeModel } from "@models/index";
import { RequestStatus } from "@constants/repositories";

export class TranslateViewModel implements ITranslateViewModel {
  public statuses: Statuses = new Statuses(["saving"]);

  private _translate: ITranslateEntity;

  public constructor(
    private model: IRootTreeModel,
    private params: { translate: TLocalTranslateObject | undefined }
  ) {
    this._translate = TranslateEntity.create(
      this.params.translate ||
        TranslateViewModel.createEmptyTranslate(undefined)
    );
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  private repository: ITranslatesRepository = new TranslatesRepository(
    new AxiosRequestClient(this.model, {})
  );

  public get translate(): ITranslateEntity {
    return this._translate;
  }

  public static createEmptyTranslate = (
    translate: Partial<TLocalTranslateObject> | undefined
  ): TLocalTranslateObject => ({
    id: 0,
    key: "",
    ...translate,
    context: "",
    segment: "api",
    translations: {
      ar: "",
      en: "",
    },
  });

  public saveTranslate = async (): Promise<TTechnicalTranslateResponse> => {
    try {
      this.statuses.setStatus("saving", RequestStatus.Pending);

      if (this._translate.id) {
        await this.repository.changeTranslate(
          this._translate.id,
          // @ts-ignore
          this._translate
        );
      } else {
        /**
         * @description validate only new keys, update old keys without validation
         */
        this.translate.validate();
        // @ts-ignore
        await this.repository.createTranslate(this._translate);
      }

      this.statuses.setStatus("saving", RequestStatus.Success);

      return this._translate as TTechnicalTranslateResponse;
    } catch (error) {
      this.statuses.setStatus("saving", RequestStatus.Error);
      throw error;
    }
  };

  /**
   * Clean up resources before destroying the view model.
   */
  public beforeDestroy = (): void => {
    this.repository.beforeDestroy();
  };
}
